/**
 * @Author: DKing
 * @Desc: axios 所需的常量
 * @Date: 2019-07-11
 */


// axios content-type
export const CONTENT_TYPE  = {
  form:'application/x-www-form-urlencoded',
  json:'application/json;charset=UTF-8',
  multipart:'multipart/form-data'
};

// http请求的返回状态码
export const HTTP_CODE = {
  suc: '000000',  // 请求成功
  err: '005000',  // 服务器打瞌睡，请稍后再试
  overtime: '014000', // 超时，后台系统，跳login页面

  illegal:'005001', // 参数非法
  notAllowed:'004001',  // 异常请求、权限不足、禁止访问

  paramsNotAllowed:'001000',  // 用户直接提示，指导用户进一步操作的信息（java自定义）
  noModal: '100100', // 不弹窗警告，资金安全账户详情接口，/cooperator/pabk/findDetail
  warning:'001001', // 不弹窗警告
  err_500: '500000', // 导入任务说明书格式错误
  expire: '600500', // 线上合同签署-小额打款验证过期
}




//////////////////
// WEBPACK FOOTER
// ./build/axios_constants.js
// module id = GL44
// module chunks = 83